module.exports = __webpack_public_path__ + "static/media/bliss-preto.dab4fbc0.webp";